/**
 * The single-use credential of an e-mailed link (invitation, password reset, e-mail proof,
 * "this wasn't me", new sign-in, e-mail preferences) and of the sign-in provider's return (#329).
 *
 * The server puts it in the URL FRAGMENT (`/accept-invitation#token=...`, built only by
 * `app/core/email/links.token_link`). A browser never sends the fragment to any server, so no
 * access log (nginx, the load balancer, Cloud Run, the api), proxy or Referer header sees it.
 * A page reads it here, removes it from the address bar before its first request, and redeems
 * it in a POST body. A token in the query string is not read: such a link is not ours.
 */

/** The value named `name` in the fragment of `hash` (the current address by default). */
export function readLinkToken(name = 'token', hash: string = globalThis.location?.hash ?? ''): string {
  // Only a fragment: `URLSearchParams` would also read a query string (`?token=`), which is
  // exactly where the credential must not be accepted from.
  if (!hash.startsWith('#')) return '';
  return new URLSearchParams(hash.slice(1)).get(name) ?? '';
}

/**
 * Leaves only the path in the address bar, so the credential stays out of the history, a
 * bookmark, a copied address and a screenshot. Safe to call more than once.
 */
export function clearLinkFromAddressBar(): void {
  globalThis.history.replaceState(null, '', globalThis.location.pathname);
}
